import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const getSecurities = createAsyncThunk(
  "securities/getSecurities",
  async ({ clientId, advisorId }, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      if (clientId) queryParams.append("clientId", clientId);
      if (advisorId) queryParams.append("advisorId", advisorId);

      const response = await getMethod(
        `/profileSummary/getSecurities?${queryParams.toString()}`
      );
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch securities"
      );
    }
  }
);

const initialState = {
  fltrsecurities: [],
  loading: false,
  success: false,
  error: null,
};

// Slice
const documentsecuritiesSlice = createSlice({
  name: "securities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSecurities.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(getSecurities.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.fltrsecurities = action.payload?.data || [];
      })
      .addCase(getSecurities.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default documentsecuritiesSlice.reducer;
